export const LIST_MASTER_REQUEST = 'LIST_MASTER_REQUEST'
export const LIST_MASTER_SUCCESS = 'LIST_MASTER_SUCCESS'
export const LIST_MASTER_FAIL = 'LIST_MASTER_FAIL'

export const PATCH_MASTER_REQUEST = 'PATCH_MASTER_REQUEST'
export const PATCH_MASTER_SUCCESS = 'PATCH_MASTER_SUCCESS'
export const PATCH_MASTER_FAIL = 'PATCH_MASTER_FAIL'

export const DETAIL_MASTER_REQUEST = 'DETAIL_MASTER_REQUEST'
export const DETAIL_MASTER_SUCCESS = 'DETAIL_MASTER_SUCCESS'
export const DETAIL_MASTER_FAIL = 'DETAIL_MASTER_FAIL'
